export const partnersRoutes = {
  default: 'affiliates',
  list: 'affiliates_list',
  add: 'add_affiliate',
  update: 'update_affiliate',
  detail: 'affiliate_detail',
}
